export default __webpack_public_path__ + "static/media/utp20.5552d11a.jpg";